module.exports = __webpack_public_path__ + "img/medium-play.a933665c.svg";